module.exports = __webpack_public_path__ + "static/media/judge-prof-ng-see-kiong.9808f0e2.jpg";